import { Outlet } from "react-router-dom";

import { useUserContext } from "../../../providers/UserProvider";
import { useOrganization } from "../../../hooks/useOrganization/useOrganization";
import { Error404 } from "../../pages/NotFound/Error404";
import { LoadingIndicator } from "../LoadingIndicator/LoadingIndicator";

/**
 * Route guard for the Agents page. Even when the virtual agent users feature flag is
 * enabled and the user is authorized, the page should only be reachable if the
 * organization has virtual agents enabled. While the organization id is not yet
 * resolved or the organization is loading we show a loading indicator to avoid flashing
 * a 404. The guard fails closed: if eligibility cannot be confirmed — the org lookup
 * errored or virtual agents are not enabled — we render the 404 page rather than grant
 * access, matching how other unavailable features behave.
 */
export const AgentsRouteGuard = () => {
    const { organizationId } = useUserContext();
    const { organization, loading, error } = useOrganization({ id: organizationId });

    if (!organizationId || loading) {
        return <LoadingIndicator />;
    }

    // Fail closed: an error means eligibility is unverifiable, so deny access even when
    // SWR is still holding stale organization data with virtualAgentsEnabled: true.
    return !error && organization?.virtualAgentsEnabled ? <Outlet /> : <Error404 />;
};

AgentsRouteGuard.displayName = "AgentsRouteGuard";
